import { AppNames, SingleSpaEventDetail } from '../types/singleSpa.types';
import { getMountedApps } from "single-spa";
import { SELF_HANDLED_SCROLLING_APPS } from '../constants/index';

export const isScrollingHandledByMf = (): boolean =>
	getMountedApps().some((mountedApp) => SELF_HANDLED_SCROLLING_APPS.includes(mountedApp));
export const isValidRouterNavigation = ({oldUrl, newUrl}: SingleSpaEventDetail): boolean => oldUrl !== newUrl;
export const isSingleSpaPushState = ({ originalEvent }: SingleSpaEventDetail): boolean => originalEvent?.singleSpaTrigger === 'pushState';
export const isScrollTop = (detail: SingleSpaEventDetail): boolean => !isScrollingHandledByMf() && isSingleSpaPushState(detail);

export const isAppMounted = (appName: AppNames): boolean => getMountedApps().includes(appName);

export const getUrlFromPath = (path: string): URL => {
	if (path.startsWith("https://") || path.startsWith("http://")) {
		return new URL(path);
	}
	return new URL(path, window.location.origin);
};
